import React from "react";
import TitleSection from "../components/TitleSection";
import { FaPhoneAlt } from "react-icons/fa";
import { TbMailFilled } from "react-icons/tb";
import Input from "./Input";
import { usePOST } from "../Tools/APIs/useMyAPI";
import { toast } from "react-toastify";

const ContactUs = ({ data }) => {
  const dataAllFooter = data?.data?.data?.contact;

  const {
    handleChangeInput,
    handleSubmit,
    successfulPost
  } = usePOST();

  const handleSubmitMain = (e) => {
    e.preventDefault();
    handleSubmit("contact-messages");
    if (successfulPost)
      toast.success("تم ارسال رسالتك بنجاح")

  };

  return (
    <section id="contact-us" className="flex flex-col w-[90%] mx-auto px-4 gap-10" dir="rtl">
      <TitleSection title="في حال وجود أي مشكلة يرجى التواصل معنا" />

      <div className="flex flex-col gap-3 items-center w-full max-w-md mx-auto text-[#1F1F1F]">
        <div className="flex items-center gap-3">
          <FaPhoneAlt size={22} color="#00386C" />
          <p className="text-lg max-sm:text-base break-words font-medium">{dataAllFooter?.phone}</p>
        </div>
        <div className="flex items-center gap-3">
          <TbMailFilled size={24} color="#00386C" />
          <p className="text-lg max-sm:text-base break-words font-medium">{dataAllFooter?.email}</p>
        </div>
      </div>

      <form
        onSubmit={handleSubmitMain}
        className="flex flex-col gap-4 w-full max-w-2xl mx-auto bg-white p-6 rounded-xl shadow-lg"
      >
        <Input
          name="name"
          onChange={handleChangeInput}
          type="text"
          placeholder="الاسم الكامل"
        />
        <Input
          name="email"
          onChange={handleChangeInput}
          type="email"
          placeholder="البريد الإلكتروني"
        />
        <Input
          name="phone"
          onChange={handleChangeInput}
          type="number"
          placeholder="رقم الهاتف"
        />
        <textarea
          name="message"
          cols={10}
          onChange={handleChangeInput}
          rows={6}
          className="text-[#333] p-4 outline-none border border-gray-300 rounded-xl resize-none"
          placeholder="اكتب رسالتك هنا..."
        />

        <button
          type="submit"
          className="bg-[#81B9DE] rounded-xl text-white font-bold w-full p-4 text-xl hover:opacity-90 transition"
        >
          إرسال الرسالة
        </button>
      </form>
    </section>
  );
};

export default ContactUs;
